// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2MZJn","paymentContainer":"PaymentPage_paymentContainer__1puz5"};